import 'rc-collapse/assets/index.css';
import { AppContext } from '../../context/AppContext';
import { config } from '../../config';
import { FormikConsumer } from 'formik';
import AutoZip from '../form/complex/AutoZip';
import axios from 'axios';
import Collapse, { Panel } from 'rc-collapse';
import CountryDropDown from '../form/simple/CountryDropDown';
import debounce from 'awesome-debounce-promise';
import DropDown from '../form/base/DropDown';
import React, { Component } from 'react';
import RepeatablePhone from '../form/complex/RepeatablePhone';
import RepeatTextField from '../form/complex/RepeatTextField';
import SimilarOrganizations from '../modal/SimilarOrganizations';
import TextField from '../form/base/TextField';
import { DrupalService } from '../../helper/DrupalService';

const fetchOrgData = async (name, street, city, state, zip, country) => {
  const params = { name, street, city, state, zip, country };
  const token = await DrupalService.getToken();

  return axios.post(config.API_DOMAIN + '/api/organization/dupe/check', params, {
    headers: {
      'accept': 'application/json',
      'content-type': 'application/json',
      'x-csrf-token': token,
    },
  })
};
const fetchOrgDataDebounced = debounce(fetchOrgData, 750);

class DetailTab extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      similarOrgs: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.clearSimilarOrgs = this.clearSimilarOrgs.bind(this);
  }

  handleChange(pairs, values) {
    let newValues = { ...values, ...pairs }

    const { organization_name_1, address_street1, address_city, address_state, address_zip, address_country } = newValues;

    if (address_street1 && address_zip && address_country === 'US') {
      fetchOrgDataDebounced(organization_name_1, address_street1, address_city, address_state, address_zip, address_country).then(response => {
        if (response.data.success && response.data.data.length > 0) {
          this.setState({ similarOrgs: response.data.data });
        }
      }).catch(error => {
        this.setState({ similarOrgs: [] });
      });
    }
  }

  clearSimilarOrgs() {
    this.setState({ similarOrgs: [] });
  }

  render() {
    return (
      <FormikConsumer>
        {({ values }) => (
          <div>
            <h2>Organization Details</h2>
            <div className="description">To avoid duplicates, please go to <a
              href="https://npin.cdc.gov/search/organizations/map">https://npin.cdc.gov/search/organizations/map</a> and
              search to see if your organization is already in NPIN. Organizations with multiple locations, please use only
              one form per location.
            </div>
            <SimilarOrganizations orgs={this.state.similarOrgs} clear={this.clearSimilarOrgs} />
            <Collapse accordion={false} defaultActiveKey={['0', '1', '2', '3', '4', '5']}>
              <Panel header="Organization Name">
                <TextField label="Organization Name Line 1"
                  name="organization_name_1"
                  onChangeCallback={(name, value) => {
                    this.handleChange({ name: value }, values);
                  }}
                  className={['form-item-org-name1']} />
                <TextField label="Organization Name Line 2"
                  name="organization_name_2" />
                <TextField label="Organization Name Line 3"
                  name="organization_name_3" />
                <RepeatTextField label="Program Name"
                  name="program_name"
                  buttonLabel="Add Program Name"
                  className={['form-item-program-name usa-button']} />
              </Panel>
              <Panel header="Address">
                <CountryDropDown
                  label="Country"
                  name="address_country"
                  onChangeCallback={(name, value) => {
                    this.handleChange({ name: value }, values);
                  }} />
                <TextField label="Address Line 1 (No PO Boxes)"
                  name="address_street1"
                  onChangeCallback={(name, value) => {
                    this.handleChange({ name: value }, values);
                  }} />
                <TextField label="Address Line 2"
                  name="address_street2" />
                <AutoZip
                  country={this.props.country}
                  name="address"
                  onChangeCallback={this.handleChange} />
              </Panel>
              <Panel header="Organization Phone">
                <RepeatablePhone
                  name="phones"
                  buttonLabel="Add Phone" />
              </Panel>
              <Panel header="Organization Web">
                <TextField label="Main Website"
                  name="website_primary"
                  placeholder="https://www.your-website.org" />
                <TextField label="Other Website"
                  name="website_other"
                  placeholder="https://other.your-website.org" />
              </Panel>
              <Panel header="Organization Service Level, Type and Legal Status" className="types-and-status">
                <div className="left-column">
                  <DropDown label="Service Level"
                    name="service_level"
                    emptyText="- Select -"
                    options={[
                      { label: 'City/Town', value: 'City/Town' },
                      { label: 'County', value: 'County' },
                      { label: 'International', value: 'International' },
                      { label: 'National', value: 'National' },
                      { label: 'State/Territory', value: 'State/Territory' },
                      { label: 'Metropolitan Area', value: 'Metropolitan Area' },
                    ]} />
                  <DropDown label="Primary Organization Type"
                    name="primary_org_type"
                    emptyText="- Select -"
                    options={this.props.formData.primary_org_type} />
                </div>
                <div className="right-column">
                  <DropDown label="Legal Status"
                    name="legal_status"
                    emptyText="- Select -"
                    options={this.props.formData.legal_status} />
                  <DropDown label="501C3 Status"
                    name="status_501c3"
                    emptyText="- Select -"
                    options={[
                      { label: 'Yes', value: 'Yes' },
                      { label: 'No', value: 'No' },
                      { label: 'Unknown', value: 'Unknown' }
                    ]} />
                </div>
              </Panel>
            </Collapse>
            <div className="submit">
              <button type="button" className='usa-button' onClick={this.props.nextTab}>Save and continue</button>
            </div>
          </div>
        )}
      </FormikConsumer>
    );
  }
}

DetailTab.defaultProps = {
  country: 'US'
};

export default DetailTab;
